<template>
  <ItemTable
    ref="itemTable"
    :collectionFilters="getCollectionFilters"
    :columns="columns"
    :details="inMainPanel"
    :gettingStartedItemType="gettingStartedItemType"
    :handleBulkDelete="handleBulkDelete"
    :handleDetailsButtonClick="handleDetailsButtonClick"
    :handleMainAction="handleMainAction"
    :handleRowClick="handleRowClick"
    :hasSelectColumn="true"
    :inDetailsAsidePanel="!inMainPanel"
    :isAsideOpen="isAsideOpen"
    :isRefreshButtonEnabled="isRefreshButtonEnabled"
    :itemType="itemType"
    :route="route"
    :selectionItemText="selectionItemText"
    :showBound="false"
    :showBulkDelete="inMainPanel"
    :showMainAction="inMainPanel"
    :showRefreshButton="true"
    :useDropDownFilterComponent="FilterComponentConsts.AppleSoftwareManagementDropDownFilter"
    :viewport="viewport"
  />
</template>

<script>
import {
  ApplePackageManagers,
  FilterComponentConsts,
  ItemTableConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import AppleVppSupportedDevices from 'client/components/ItemTable/BodyComponents/AppleVppSupportedDevices.vue';
import CommandStatus from 'client/components/ItemTable/BodyComponents/CommandStatus.vue';
import ItemTable from 'components/ItemTable/ItemTable';
import ItemTableComputedMixin from 'components/ItemTable/mixins/ItemTableComputedMixin';
import ItemTableMethodsMixin from 'components/ItemTable/mixins/ItemTableMethodsMixin';
import ItemTablePropsMixin from 'components/ItemTable/mixins/ItemTablePropsMixin';
import ModalEventBus from 'components/Modal/ModalEventBus';
import RouterService from 'client/util/RouterService';
import Util from 'client/util/Util';
import VppAppIcon from 'client/components/ItemTable/BodyComponents/VppAppIcon.vue';
import VppSoftwareAppsDeleteModal from 'client/SoftwareApps/VppSoftwareAppsDeleteModal.vue';

const { columnTypes } = ItemTableConsts;
const softwareAppsCollection = StoreModuleMap[ItemTypeConsts.softwareApps];

export default {
  name: 'VppSoftwareAppsItemTable',

  components: {
    ItemTable,
  },

  mixins: [
    ItemTableComputedMixin,
    ItemTableMethodsMixin,
    ItemTablePropsMixin,
  ],

  data: () => ({
    itemType: ItemTypeConsts.softwareApps,
    route: `/${ItemTypeRoutes[ItemTypeConsts.softwareApps]}`,
    columns: [
      {
        bodyComponent: VppAppIcon,
        classNames: {
          body: [columnTypes.iconColumn],
        },
      },
      {
        dataField: 'displayName',
        headingText: 'Name',
        sortBy: 'displayName',
      },
      {
        bodyComponent: AppleVppSupportedDevices,
        bodyComponentProps: {
          arrayField: 'settings[0].appleVpp.supportedDeviceFamilies',
        },
        headingText: 'Supported Devices',
      },
      {
        dataField: 'settings[0].location',
        headingText: 'Location Name',
      },
      {
        bodyComponent: CommandStatus,
        bodyComponentProps: {
          softwareTypeField: 'settings[0].packageManager',
        },
        headingText: 'Command Status',
      },
    ],
    FilterComponentConsts,
  }),

  computed: {
    ...mapGetters(softwareAppsCollection, {
      selectedItems: 'getSelectedItems',
      getApps: 'getItem',
      getTotalCount: 'getTotalCount',
    }),

    getCollectionFilters() {
      return [{ name: 'packageManager', operator: 'in', value: Object.values(ApplePackageManagers).join('|') }];
    },

    isRefreshButtonEnabled() {
      return this.getTotalCount > 0;
    },
  },

  methods: {
    ...mapActions(softwareAppsCollection, [
      'deleteItems',
      'setDeletedItemIds',
    ]),

    closeAsidePanel() {
      RouterService.redirect({
        path: `${this.route}/apple`,
        triggeredEvent: this.asidePanelCanceledEventName,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },

    deleteSelectedCustomApps() {
      this.deleteItems(this.selectedItems)
        .then(this.notifyDeleteItems)
        .finally(() => {
          ModalEventBus.close();
        });
    },

    handleBulkDelete() {
      this.closeAsidePanel();
      this.showDeleteModal();
    },

    handleDetailsButtonClick(itemId) {
      const item = this.getApps(itemId);
      const softwareType = item.settings[0].packageManager === ApplePackageManagers.appleVpp ? 'apple' : 'custom';
      if (this.inMainPanel && this.viewport) {
        this.viewport.redirect(`${this.route}/${softwareType}/${itemId}/details`);
      } else {
        Util.redirect(`${this.route}/${softwareType}/${itemId}/details`);
      }
    },

    handleMainAction() {
      if (this.viewport) {
        this.viewport.redirect(`${this.route}/apple/new`);
      } else {
        Util.redirect(`${this.route}/apple/new`);
      }
    },

    notifyDeleteItems(res) {
      this.setDeletedItemIds({ deletedItemIds: res.deletedIds, failedTasks: res.failedTasks });
    },

    showDeleteModal() {
      ModalEventBus.open({
        component: VppSoftwareAppsDeleteModal,
        componentProps: {
          action: this.deleteSelectedCustomApps,
          itemType: this.itemType,
        },
      });
    },
  },
};
</script>
